<template>
	<div style="text-align: left; position: relative;" >
		<div v-html="dataSubString" @mouseover="startHover">
		</div>

		<div v-if="showFull" ref="fullData" v-html="dataString" class="floater-data" @mouseleave="stopHover">
		</div>
	</div>
</template>

<script>
    export default {
        name: "NameClusterCell",
        data() {
            return {
                dataString: "",
				dataSubString: "",
				showFull: false,
				nameLength: 0
            }
        },
        props: {
            header: {
                type: Object,
                default: () => {}
            },
            cell_data: {
                type: Object,
                default: () => {}
            },
            field: {
                type: String,
                default: () => ""
            }
        },
        mounted() {
        	this.setFieldString();
        },
        methods: {
        	setFieldString(){
				if(this.cell_data[this.field] && this.cell_data[this.field].length){
					let names = [];
					for(let i = 0; i < this.cell_data[this.field].length;++i){
						names.push(this.cell_data[this.field][i].name);
					}

					this.dataString =  names.join("<br />") ;
					if(names.length > 1){
						this.dataSubString = names[0] + "&hellip;";
					} else {
						this.dataSubString = names[0];
					}
					this.nameLength = names.length;
				} else {
					this.dataString = "";
					this.dataSubString = "";
					this.nameLength = 0;
				}

			},
			startHover(){
        		if(this.nameLength > 1){
					this.showFull = true;
				}
			},
			stopHover(){
        		this.showFull = false;
			}
		},
		watch: {
        	cell_data: function(){
        		this.setFieldString();
			}
		}
    }
</script>
